export default {
  banner: {
    title: "应用集成网关",
    subtitle:
      "应用集成网关赋予老旧应用快速集成 Authing 身份云产品的能力。在扩充身份认证方式的同时，保护原有系统资源免受非法侵害。",
    img: " //files.authing.co/authing-website/gateway-banner-img-v2.png",
  },
  features: {
    data1: {
      label: "减少运维成本",
    },
    data2: {
      label: "降低安全风险",
    },
    data3: {
      label: "提高生产效率",
    },
    item1: {
      title: "智能的安全保护，伴随应用的每一次访问管理",
      list1: {
        title: "统一访问管理",
        descript:
          "你的混合云需要更安全的访问管理，通过集中访问控制，为本地应用创建高效、统一的安全策略。",
      },
      list2: {
        title: "智能保护",
        descript:
          "部署在本地的应用集成网关，利用智能安全防护，为应用系统提供安全保护层。",
      },
    },
    item2: {
      title: "轻量级架构，低成本运维",
      img: "gateway-integartion-framework-new.png",
      descript:
        "基础设施运维成本占比的减少对于企业至关重要，应用集成网关可将身份基础设施减少 90%，意味着需要更少的计算资源和维护成本，极大降低企业运营成本，保障数据安全。",
    },
    item3: {
      title: "开发者友好，零代码集成",
      descript:
        "无需更改应用系统代码，就能与老应用做身份集成，快速支持数十种认证方式，省去应用集成的高成本。",
    },
  },
  functions: {
    title: "以高效功能，助你业务更上一层楼",
    item1: {
      title: "应用生命周期管理",
      descript:
        "通过应用生命周期管理功能，快速、高效管理应用：包括应用的创建、启用、禁用、维护和删除。",
    },
    item2: {
      title: "流量控制",
      descript:
        "可以针对特定的接口进行用户和源 IP 请求频率的管控，用于保障后端服务的稳定运行。",
    },
    item3: {
      title: "监控告警",
      descript:
        "提供实时、可视化的应用监控，包括：接口请求次数、接口调用延迟和接口错误信息，通过监控面板更清晰地了解接口的调用情况，识别可能影响业务的潜在风险，并通过多种通知方式及时通知到相关负责人。",
    },
    item4: {
      title: "访问控制",
      descript:
        "应用集成网关可以与身份认证平台进行信息交互，并将身份认证平台中的用户、角色、访问策略等信息同步到网关侧，在网关侧进行用户访问权限的判定，以此来实现应用访问用户权限的静态、动态分配。",
    },
    item5: {
      title: "安全防护及安全审计日志",
      descript:
        "所有的应用系统拥有一个统一的出入口，日志集中管理，后续的安全审计更加方便。对外暴露的访问服务仅有网关服务，由网关服务根据策略动态处理用户请求，既增强了原有系统隐藏性，并且用户无感知。所有通过网关的访问请求都会统一做用户登录校验以及权限的校验。",
    },
  },
  process: {
    title: "Authing 应用集成网关认证流程",
  },
};
